export default __webpack_public_path__ + "static/media/movie-details-bg.c5606e91.jpg";